{
	"main": {
		"titleAktivnosti": "ATTIVITÀ ODIERNE IN CIELO",
		"subtitleAktivnosti": "ATTIVITÀ NELLA DATA SELEZIONATA"
	},
	"labels": {
		"datum": "Data dell'attività:"
	},
	"aktivnosti": {
		"title": "Panoramica delle attività per data",
		"opozorila": "AVVISI",
		"cas": "Ora:",
		"vnesel": "Inserito:",
		"mainTitle": "PROGRAMMA DI VOLO"
	},
	"razpored": {
		"titleJ": "Aerei a vela",
		"titleM": "Aerei a motore",
		"titleUL": "Aerei UltraLeggeri",
		"let": "Volo",
		"planirano": "Programmato:",
		"naloga": "Compito:",
		"sredstvo": "Mezzo:",
		"vrstaLetala": "Tipo di aereo:",
		"izvrsilec": "Esecutore dell'ispezione dell'aereo:",
		"podpis": "Firma:"
	},
	"obvestila": {
	  "brisiSredstvo": "Sei sicuro di voler eliminare il bene?",
	  "vnosUspesen": "Inserimento riuscito",
	  "vnosNeuspesen": "Errore nel recupero dei dati.",
	  "nepricakovanaNapaka": "Si è verificato un errore imprevisto",
	  "poslano": "Messaggio inviato",
	  "niPoslano": "Il messaggio non è stato inviato"
	}

}